import React from 'react';
import { isPastDateField } from 'common/helpers';
import { FieldContainer } from 'public/components/FieldContainer';
import ModularDatePicker from 'public/components/ModularComponents/DatePicker';

export default function DateInput({ input, handleInputChange, value, locked }) {
  const { name, label, required, placeholder } = input.fields;

  return (
    <FieldContainer>
      <label htmlFor={name}>{`${label}${required ? ' *' : ''}`}</label>
      <ModularDatePicker
        date={value}
        setDate={(date) => handleInputChange({ ...input.fields, value: date })}
        placeholder={placeholder}
        readOnly={locked}
        pastOnly={isPastDateField(input.fields)}
      />
    </FieldContainer>
  );
}
